<script setup>
import { ref } from "vue";

const props = defineProps({
  comment: {
    type: String,
    default: ""
  }
});

const emit = defineEmits(["save-comment"]);
const comment = ref(props.comment);
</script>

<template>
  <div class="image-review-request">
    <div class="image-review-request__title">Free Design Editing (optional)</div>

    <textarea
      v-model="comment"
      maxlength="500"
      class="image-review-request__textarea"
      placeholder="For example - Remove background and sharpen image. Change font color to red."
      @change="emit('save-comment', comment)"
    />
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/pod/settings";
@import "frontend/init/jiffy/button/mixin";

.image-review-request {
  &__title {
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 16px;
    font-weight: bold;
    color: $pod-gray-modern-800;
  }

  &__textarea {
    display: block;
    width: 100%;
    height: 100px;
    font-size: 14px;
    line-height: 18px;
    padding: 8px;
    color: $pod-gray-modern-800;
    border: 1px solid $pod-gray-modern-300;
    border-radius: 4px;
  }
}
</style>
